import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';

/** @class PopoverIconMixin */
/** @method */
export var PopoverIconMixin = token('Popover.icon.size', function (size) {
  return css(["height:", "px;width:", "px;", "{height:100%;width:100%;}"], size, size, StyledIcon);
});